<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.value"
            :error-messages="valueErrors"
            :label="item['name']"
            required
            @input="$v.item.value.$touch()"
            @blur="$v.item.value.$touch()"
          />
        </v-col>
      </v-row>



    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'SecurityParameterForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
        name: null,
        value: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    valueErrors() {
      const errors = [];

      if (!this.$v.item.value.$dirty) return errors;

      has(this.violations, 'value') && errors.push(this.violations.value);

      !this.$v.item.value.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      value: {
        required,
      },
    }
  }
};
</script>
